import { compact } from 'lodash';
import { toast } from 'react-toastify';
import {
  resolveSearch,
  SEARCH_FUSE_OPTIONS,
  withSearchAliases,
} from '../../utils/conditionSearch';
import { initFunnelSession, track } from '../../utils/funnelTracking';
import { VIEW_KEYS, EVENT_TYPES } from '../../utils/funnelConstants';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';

import {
  SearchIcon,
  DollarIcon,
  BlueCheckMark,
  ArrowRightLong,
  ArrowBlackLong,
  ArrowRightShort,
} from '../../assets/icons';
import {
  newImage,
  testDisease,
  theDoctor,
  trustPilotReviewNew,
  heroAllConditions,
  theStars,
  weightLossStep1,
  weightLossStep2,
  aboutUsStep3,
  starsRow,
  trustPilotNewer,
  medicationSection3,
  serviceSection3,
  homeStep3,
} from '../../assets/images';

import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import {
  AddSearchTerm,
  LoadService,
  LoadServiceCategory,
  slimServiceForListing,
} from '../../DB/DB';

import Questions from '../../components/questions';
import Ribbon from '../../components/ribbon';
import Steps from '../../components/steps';
import { TrustBoxWide } from '../../components/trustBox';

import { notFoundFolder } from '../../assets/images';
import Slider from 'react-slick';

import { useDocContext } from '../../context/DocContext';
import { Container, Row, Col } from 'react-bootstrap';
export default function Index({ services }) {
  const [AllServices, setAllServices] = useState([]);
  const [currentCategory, setCurrentCategory] = useState(
    services[0]?.objectId ?? null
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const buttonRef = useRef(null);
  const { hasSubscription } = useDocContext();
  const router = useRouter();
  const fragment = router.asPath.split('#')[1]; //!!This is undefined,so seems unnecessary,redundant?//
  // console.log('FRAGMENT', fragment);
  const sliderRef = useRef(null);
  //**Logic required for react-slick for categories tabs for mobile screens */
  const [isMobile, setIsMobile] = useState(false);
  const [showAllConditions, setShowAllConditions] = useState(false);
  const VISIBLE_LIMIT = 9;

  // Funnel baseline: entry point for funnel 2 (browsed the services page).
  // initFunnelSession is a no-op if the session already started on the
  // homepage, so a home -> services -> condition path keeps one session id.
  useEffect(() => {
    initFunnelSession({ isLoggedInAtEntry: false, isNewUserFlow: true });
    track(VIEW_KEYS.SERVICES_LIST, EVENT_TYPES.VIEWED);
  }, []);
  // Check screen size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // Decode the URI component to convert %20 back to spaces
  const decodedFragment = decodeURIComponent(fragment); //!!This is undefined,so seems unnecessary,redundant?//
  // With ISR the query string isn't available at build time, so pick up
  // ?categoryID= on the client once the router has hydrated
  const queryCategoryID = router.query.categoryID;
  useEffect(() => {
    if (router.isReady && queryCategoryID !== undefined) {
      setCurrentCategory(queryCategoryID);
    }
  }, [router.isReady, queryCategoryID]);
  // console.log('DECODED', decodedFragment);
  const handleOnSelect = async (e) => {
    await AddSearchTerm(e.title, e.objectId);
    router.push(`/services/${e.objectId}/${adjustTitle(e.title)}`);
    // router
  };
  const handleOnSearch = async (string, results) => {
    //for checking the search terms
    //console.log('IN THE HANDLE ON SEARCH', string, results?.[0]?.objectId);
    setSearchTerm(string);
    setSearchResults(results);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const match = resolveSearch(searchTerm, searchResults);
    if (!match) {
      // Nothing we treat matched. Saying so beats dropping the patient on
      // whichever condition scored least badly, which is what the old
      // unconditional searchResults[0] push did.
      if (searchTerm) {
        toast.info(
          `We don't currently treat "${searchTerm}". Try browsing our conditions below.`
        );
      }
      return;
    }
    await AddSearchTerm(searchTerm, match.objectId);
    router.push(`/services/${match.objectId}/${adjustTitle(match.title)}`);
  };

  const formatResult = (item) => {
    return (
      <>
        <span className='conditionName'>{item.title}</span>
      </>
    );
  };
  useEffect(() => {
    if (buttonRef.current) {
      setTimeout(() => {
        buttonRef.current.click();
      }, 100); // Adjust the delay as necessary
    }
  }, [decodedFragment, services]);
  useEffect(() => {
    let all = [];
    for (let cat in services) {
      all.push(services[cat].diseases);
    }
    setAllServices(
      all.flat().map((c, i) => {
        return { ...c, id: i };
      })
    );
    setCategory(currentCategory);
  }, [currentCategory, services]);
  //console.log('SERVICES', services);
  let setCategory = (id) => {
    setCurrentCategory(id);
    var allElements = document.getElementsByClassName('categoryName');
    for (let i = 0; i < allElements.length; i++) {
      if (allElements[i].className.split(' ')[1] == id) {
        allElements[i].className = `categoryName ${id} goGreen`;
      } else {
        allElements[i].className = allElements[i].className.replace(
          'goGreen',
          ''
        );
      }
    }
  };
  // Find the index of the currently selected category
  const currentIndex = services.findIndex(
    (cat) => cat.objectId === currentCategory
  );

  // Use effect to update slider position when currentCategory changes
  useEffect(() => {
    if (sliderRef.current && currentIndex !== -1) {
      // Move to the slide containing the active category
      sliderRef.current.slickGoTo(currentIndex);
    }
  }, [currentCategory, currentIndex]);

  const handleClick = (id) => {
    setCategory(id);
    setShowAllConditions(false);
  };
  const goToLink = () => {
    router.push('/services/0IAR9Ij8yG/urgent-medical-care-');
  };
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    //initialSlide: 0,
    initialSlide: currentIndex !== -1 ? currentIndex : 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const CategoriesLarge = () => {
    return (
      <div className='tw-flex tw-items-center tw-w-full tw-gap-x-4 2xl:tw-justify-between'>
        <div className='serviceCategoryList tw-flex tw-gap-x-4 tw-overflow-x-auto tw-whitespace-nowrap'>
          {services
            .filter(
              (cat) =>
                cat.objectId !== 'H6Klqxne58' &&
                cat.objectId !== '1LHzR8eHNc' &&
                cat.objectId !== 'iezHwCrWYY'
            )
            .map((cat) => (
              <button
                key={cat.objectId}
                onClick={() => handleClick(cat.objectId)}
                className={`tw-flex-1 tw-h-[58px] tw-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-rounded-2xl tw-text-sm tw-cursor-pointer tw-whitespace-nowrap tw-tracking-[.75px] tw-border-0 ${
                  cat.objectId === currentCategory
                    ? 'active-cat'
                    : 'tw-bg-black tw-text-white'
                }`}
              >
                {cat.title}
              </button>
            ))}
        </div>
      </div>
    );
  };
  const CategoriesMobile = () => {
    return (
      <div className=''>
        <div className=''>
          <Slider ref={sliderRef} {...settings} className=''>
            {services
              .filter(
                (cat) =>
                  cat.objectId !== 'H6Klqxne58' &&
                  cat.objectId !== '1LHzR8eHNc' &&
                  cat.objectId !== 'iezHwCrWYY'
              )
              .map((cat) => (
                <div key={cat.objectId} className='tw-mr-4'>
                  <button
                    onClick={() => handleClick(cat.objectId)}
                    className={`${
                      cat.objectId === currentCategory
                        ? 'active-cat tw-px-4 tw-py-3 tw-w-[224px] tw-h-[58px] tw-text-sm tw-whitespace-nowrap tw-border-0  tw-tracking-[.75px]'
                        : ' tw-tracking-[.75px] tw-border-0 tw-px-2 tw-py-3 tw-w-[224px] tw-h-[58px] tw-bg-black tw-text-white tw-rounded-2xl tw-text-sm tw-text-center tw-cursor-pointer tw-whitespace-nowrap'
                    }`}
                  >
                    {cat.title}
                  </button>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    );
  };
  return (
    <main className='about'>
      <Script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        strategy='lazyOnload'
      />
      <Head>
        <title>24/7 Online Doctors | Affordable Virtual Care - 24hrdoc</title>
        <meta
          name='description'
          content='Get 24/7 access to online doctors with 24hrdoc. Affordable virtual care, expert medical consultations, and prescriptions—no insurance needed!'
        />
        <meta
          name='keywords'
          content='24/7 online consultations,online medical consultation,talk to a doctor online'
        />
        <meta
          property='og:image'
          content={
            'https://www.24hrdoc.com/_next/image?url=%2Fassets%2Fimages%2Fnew%2FtransformXL.png&w=640&q=80'
          }
        />
        <link rel='icon' href='/favicon.ico' />
        <link rel='canonical' href='https://www.24hrdoc.com/services' />
      </Head>
      {/* <PageHeaderNew
        name='Services'
        heading='Services'
        subtext="Explore 24HrDOC's personalized telehealth treatments, offering quick, confidential, and convenient online services for a range of conditions from mental health to dermatology. Starting at just $39.99, access expert care for everything from acne to allergies, anytime, anywhere."
      /> */}
      {/* <HowItWorksNew /> */}
      {/* The Hero Section */}
      <section className='tw-w-full tw-py-8 lg:tw-py-16'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
          <Container fluid className=''>
            <Row className=''>
              <div className='position-relative tw-w-full tw-h-full md:tw-hidden tw-mb-4'>
                <Image
                  src={heroAllConditions}
                  layout='responsive'
                  width={343}
                  height={166}
                  alt='Women needing medication'
                  className='tw-rounded-2xl'
                />
              </div>
              <Col xs={12} lg={6} className='px-0'>
                <div className='tw-text-base lg:tw-text-xl tw-flex tw-items-center tw-gap-x-2 tw-mb-6'>
                  <DollarIcon />
                  <div className='tw-flex tw-items-center tw-gap-x-2'>
                    {' '}
                    <div>
                      <span className='tw-mb-0 tw-text-[#1F6BB3]'>
                        Starting at just
                      </span>{' '}
                      <span className='gradientText'>$39.99</span>
                    </div>{' '}
                    <div className='tw-flex tw-items-center tw-gap-x-2'>
                      <div className='tw-hidden lg:tw-block tw-w-[10px] tw-h-[10px] tw-rounded-full tw-bg-[#1F6BB3]'></div>
                      <span className='tw-text-[#1F6BB3]'> No hidden fees</span>
                    </div>
                  </div>
                </div>
                <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-4 lg:tw-gap-y-8 xl:tw-w-[85%]'>
                  <div className='tw-flex tw-flex-col tw-gap-y-8'>
                    <div className='tw-flex tw-flex-col tw-gap-y-2 lg:tw-gap-y-8'>
                      <h1 className='tw-m-0 tw-font-semibold tw-text-4xl lg:tw-text-5xl XL:tw-text-[3.5rem] tw-leading-[3rem] lg:tw-leading-[4rem]'>
                        Get the care you{' '}
                        <br className='tw-hidden xl:tw-block' /> need —{' '}
                        <span className='gradientText'>fast.</span>
                      </h1>
                      <p className='tw-m-0 tw-text-[#5f5f5f] tw-max-w-[520px] xl:tw-max-w-full'>
                        Online treatment for 40+ common conditions.
                        Board-licensed doctors. Prescriptions sent to your
                        pharmacy fast — all from your phone or computer.
                      </p>
                    </div>
                    <ul className='tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-y-6'>
                      <li className='tw-flex tw-items-center tw-gap-x-2 lg:tw-text-xl tw-text-ribbon_blue'>
                        <div className='tw-flex-shrink-0'>
                          <BlueCheckMark />
                        </div>
                        No Insurance Needed
                      </li>
                      <li className='tw-flex tw-items-center tw-gap-x-2 lg:tw-text-xl tw-text-ribbon_blue'>
                        <div className='tw-flex-shrink-0'>
                          <BlueCheckMark />
                        </div>
                        Prescription in as little as 45 minutes
                      </li>
                    </ul>
                  </div>
                  <div className='tw-w-full  tw-flex tw-flex-col tw-gap-y-4'>
                    {' '}
                    <div className='tw-w-full  hero-home-new-cta'>
                      <Link href='#conditions'>
                        <button className='tw-w-full tw-bg-none tw-border-none tw-px-6 tw-h-14 lg:tw-h-[62px] tw-bg-black tw-text-base lg:tw-text-xl tw-font-semibold tw-text-white tw-rounded-full tw-flex tw-items-center tw-gap-x-2 tw-justify-center'>
                          Get treatment
                          <ArrowRightShort />
                        </button>
                      </Link>
                    </div>
                    <p className='tw-m-0 tw-text-center tw-font-medium tw-text-[#5f5f5f] tw-text-base'>
                      Takes less than 3 minutes.
                    </p>
                  </div>
                  <div className='tw-bg-[#FAF9F9]  tw-py-6 tw-px-3 tw-flex tw-items-center tw-gap-x-10 tw-justify-center tw-rounded-2xl'>
                    <Image
                      src={trustPilotReviewNew}
                      alt='Trustpilot Reviews'
                      width={216}
                      height={91}
                    />
                    <div className='tw-flex tw-flex-col tw-items-center tw-gap-y-2'>
                      <span className='tw-m-0 tw-text-xl tw-font-medium'>
                        Excellent
                      </span>
                      <Image src={theStars} alt='4.5 Stars' width={140} height={20} />
                      <span className='tw-m-0 tw-text-[#5F5F5F] tw-text-sm lg:tw-text-base tw-text-center lg:tw-text-left'>
                        4.2 out of 5 avg. rating*
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={6} className='tw-flex px-0 '>
                <div className='position-relative tw-w-full tw-h-full'>
                  <Image
                    src={heroAllConditions}
                    layout='fill'
                    alt='Smiling woman in a blazer looks at her phone outdoors, standing amid greenery with modern glass buildings in the background.'
                    objectFit='cover'
                    className='tw-rounded-2xl'
                  />
                </div>
              </Col>
            </Row>
          </Container>
          <div
            style={{ background: 'linear-gradient(to right,#1F6BB3,#49D1AB)' }}
            className='tw-mt-5 lg:tw-mt-10 tw-px-4 lg:tw-px-8 tw-py-6 lg:tw-py-12 tw-rounded-2xl tw-flex tw-items-center tw-gap-x-6 tw-text-white'
          >
            {' '}
            {/* <div className='tw-relative tw-w-[75px] tw-h-[75px] lg:tw-w-[113px] lg:tw-h-[113px]'>
              <Image src={newImage} layout='fill' alt='' />
            </div> */}
            <img
              src={newImage}
              width={75}
              height={75}
              alt='doctor-image'
              className='lg:tw-hidden'
            />
            <img
              src={newImage}
              width={113}
              height={113}
              alt='doctor-image'
              className='tw-hidden lg:tw-block'
            />
            <div className='tw-flex tw-items-center tw-w-full'>
              <div className='tw-flex tw-flex-col tw-gap-y-2 lg:tw-gap-y-6 lg:tw-flex-1'>
                <p className='tw-m-0 tw-font-medium lg:tw-text-4xl'>
                  Not sure what you have?
                </p>
                <p className='tw-m-0 tw-text-sm lg:tw-text-2xl tw-font-light'>
                  Speak with a licensed provider and get guidance fast.
                </p>
              </div>
              <button
                onClick={() => goToLink()}
                className='tw-flex-shrink-0 tw-border-none tw-bg-transparent tw-w-10 tw-h-10 tw-rounded-full tw-bg-white plain-cta'
              >
                <ArrowBlackLong />
              </button>
            </div>
          </div>
        </div>
      </section>
      <Ribbon />
      <section className='tw-w-full tw-py-8 lg:tw-py-16'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem] tw-flex tw-flex-col '>
          <div className='tw-w-full tw-flex tw-flex-col '>
            <p className=' tw-text-ribbon_blue lg:tw-text-xl tw-font-medium tw-mb-4'>
              40+ Conditions Covered
            </p>
            <div className='tw-flex tw-flex-col tw-gap-y-4 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between tw-w-full tw-mb-6'>
              <h2 className='tw-m-0 tw-text-[2rem] tw-font-semibold xl:tw-text-5xl'>
                Find <span className='gradientText'>the care you need</span>
              </h2>
              <p className='tw-m-0 tw-text-[#5f5f5f]'>
                Starting at just $39.99, access expert care for everything
                <br className='tw-hidden xl:tw-block' /> from acne to allergies,
                anytime, anywhere.
              </p>
            </div>
            <form onSubmit={handleSubmit}>
              <div className=' tw-mb-4 tw-relative'>
                <button type='submit' className='searchIconContainer'>
                  <SearchIcon />
                </button>
                <ReactSearchAutocomplete
                  items={withSearchAliases(AllServices)}
                  onSearch={handleOnSearch}
                  onSelect={handleOnSelect}
                  resultStringKeyName='title'
                  fuseOptions={SEARCH_FUSE_OPTIONS}
                  formatResult={formatResult}
                  placeholder='Search Condition'
                  maxResults={5}
                  className='tw-z-40'
                  styling={{
                    fontSize: '14px',
                    fontFamily: 'Poppins',
                    padding: '12px 24px',
                  }}
                />
              </div>
            </form>
          </div>

          <div className='' id='conditions'>
            <div className=''>
              {isMobile ? <CategoriesMobile /> : <CategoriesLarge />}

              {/* This is where the active tag content will go */}
              <Container fluid className='tw-mt-8 px-0'>
                <Row className='g-3'>
                  {' '}
                  {(() => {
                    const currentCat = services.find(
                      (cat) => cat.objectId === currentCategory
                    );
                    const allDiseases = currentCat?.diseases || [];
                    const visibleDiseases =
                      isMobile && !showAllConditions
                        ? allDiseases.slice(0, VISIBLE_LIMIT)
                        : allDiseases;
                    return allDiseases.length > 0 ? (
                      <>
                        {visibleDiseases.map((disease) => (
                          <Col xs={12} md={6} lg={4} key={disease.objectId}>
                            <Link
                              href={`/services/${
                                disease.objectId
                              }/${disease.title
                                .toLowerCase()
                                .replace(/[\s+#]/g, '-')}`}
                            >
                              <div
                                style={{ border: '1px solid #D9D9D9' }}
                                className='tw-p-4 tw-rounded-2xl tw-cursor-pointer'
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <div className='tw-flex tw-items-center tw-gap-x-5'>
                                    <div className='tw-flex-shrink-0'>
                                      <Image
                                        src={disease.thumbnail || testDisease}
                                        width={60}
                                        height={60}
                                        alt='the image'
                                      />
                                    </div>
                                    <div>
                                      <p className='tw-capitalize tw-text-lg tw-font-medium tw-m-0 tw-p-0 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-max-w-[180px] lg:tw-max-w-[150px] XL:tw-max-w-[250px]'>
                                        {disease.title}
                                      </p>
                                      <span
                                        style={{
                                          color: '#606060',
                                          fontSize: '1rem',
                                          margin: '0',
                                          padding: '0',
                                        }}
                                      >
                                        Starting at just $
                                        {hasSubscription
                                          ? '20.00'
                                          : disease?.Price}
                                      </span>
                                    </div>
                                  </div>
                                  <div className='tw-flex-shrink-0 plain-cta'>
                                    <ArrowBlackLong />
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                        ))}
                        {isMobile && allDiseases.length > VISIBLE_LIMIT && (
                          <div className='tw-w-full tw-flex tw-justify-center tw-mt-6'>
                            <button
                              type='button'
                              className='tw-text-base tw-font-medium tw-border tw-border-[#d8d8d8] tw-border-solid tw-rounded-full tw-px-16 tw-py-[.85rem] tw-bg-transparent hover-scale'
                              onClick={() => setShowAllConditions((v) => !v)}
                            >
                              {showAllConditions
                                ? 'View less'
                                : 'View all conditions'}
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          border: '0.5px solid #6060604d',
                          borderRadius: '1rem',
                        }}
                        className='tw-flex tw-flex-col tw-items-center tw-p-3'
                      >
                        <Image
                          src={notFoundFolder}
                          width={64}
                          height={64}
                          alt='service-not-found-image'
                        />
                        <p className='tw-text-[#5f5f5f] tw-text-center'>
                          {' '}
                          Unfortunately,we don&apos;t treat this condition
                        </p>
                      </div>
                    );
                  })()}
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </section>
      <Steps
        superText={'Simple 3-Step Process'}
        subText=<div>
          Advanced care — without the complexity.
          <br className='tw-hidden lg:tw-block' />
          If approved, your prescription is sent to your pharmacy for pickup
          often within hours.
        </div>
        steps={steps}
        buttonText={'Get treatment'}
        showTicker={false}
        path={'#conditions'}
      />
      <section className='tw-w-full tw-py-8 lg:tw-py-16'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
          <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-4'>
            <p className='tw-m-0 tw-font-medium tw-text-[#195D9D] lg:tw-text-xl'>
              Patient Reviews
            </p>
            <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-2 lg:tw-flex-row lg:tw-items-center'>
              <div className='tw-flex tw-flex-col tw-gap-y-4 lg:tw-flex-1'>
                <p className='tw-m-0 tw-text-2xl xl:tw-text-4xl tw-font-semibold'>
                  Trusted by 12,000+ patients nationwide.
                </p>
                <h2 className='tw-m-0 tw-font-semibold tw-text-[2rem] xl:tw-text-5xl'>
                  Real relief. Real prescriptions.
                  <span className='gradientText'>Real fast.</span>
                </h2>
                <p className='tw-m-0 tw-text-[#5f5f5f]'>
                  Over 80% of patients complete treatment in under 15 minutes.
                </p>
              </div>
              <div className=' tw-flex tw-flex-col tw-items-center lg:tw-items-start tw-gap-y-2'>
                <p className='tw-m-0 tw-text-[2.5rem] tw-font-semibold'>4.2</p>
                <div className=' tw-flex tw-flex-col  tw-items-center lg:tw-items-start tw-gap-y-1'>
                  <Image src={starsRow} width={120} height={24} alt='Four Stars' />
                  <span className='tw-m-0 tw-text-[#5f5f5f]'>
                    Based on 13,000+
                  </span>
                </div>
                <Image src={trustPilotNewer} width={140} height={30} alt='Trustpilot' />
              </div>
            </div>
          </div>
          <div className='tw-w-full tw-py-8 lg:tw-py-16'>
            {' '}
            <TrustBoxWide />
          </div>
        </div>
      </section>

      <section className='tw-w-full tw-pt-0 tw-pb-8 lg:tw-pb-16'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
          <Container fluid className='px-0'>
            <Row className='px-lg-0'>
              <Col xs={12} lg={6} className='px-lg-0'>
                <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-0 lg:tw-gap-y-4'>
                  <p className='tw-m-0 tw-font-medium lg:tw-text-xl tw-text-[#195D9D]'>
                    Licensed Medical Providers{' '}
                  </p>
                  <div className='tw-flex tw-flex-col tw-gap-y-6'>
                    <div className='tw-flex tw-flex-col tw-gap-y-4 lg:tw-gap-y-8'>
                      <h2 className='tw-m-0 tw-font-semibold tw-text-[2rem] lg:tw-text-5xl  XL:tw-text-[3.5rem] tw-leading-[3rem]  xl:tw-leading-[4.5rem]'>
                        <span className='gradientText'>Fast</span> care, without{' '}
                        <br className='tw-hidden xl:tw-block' />
                        <span className='gradientText'>cutting</span> corners.
                      </h2>
                      <p className='tw-m-0 tw-text-[#5f5f5f]'>
                        Every treatment request is personally reviewed by a
                        U.S.- <br className='tw-hidden xl:tw-block' />
                        licensed, board-certified provider to ensure it’s safe,{' '}
                        <br className='tw-hidden xl:tw-block' />
                        appropriate, and tailored to you
                      </p>
                    </div>
                    <ul className='tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-y-4 lg:tw-gap-y-6'>
                      <li className='tw-flex tw-items-center tw-gap-x-2 tw-text-sm lg:tw-text-xl tw-text-[#5f5f5f]'>
                        <div className='tw-flex-shrink-0'>
                          <BlueCheckMark />
                        </div>
                        Ongoing follow-up support
                      </li>
                      <li className='tw-flex tw-items-center tw-gap-x-2 tw-text-sm lg:tw-text-xl tw-text-[#5f5f5f]'>
                        <div className='tw-flex-shrink-0'>
                          <BlueCheckMark />
                        </div>
                        No insurance required
                      </li>
                      <li className='tw-flex tw-items-center tw-gap-x-2 tw-text-sm lg:tw-text-xl tw-text-[#5f5f5f]'>
                        <div className='tw-flex-shrink-0'>
                          <BlueCheckMark />
                        </div>
                        Secure & encrypted medical records
                      </li>
                    </ul>
                  </div>{' '}
                  <div className='hero-home-new-cta tw-w-full lg:tw-w-max tw-mt-4 lg:tw-mt-0'>
                    <Link href='#conditions'>
                      <button className='tw-w-full tw-bg-none tw-border-none tw-px-6 tw-py-3  tw-bg-black tw-text-white tw-rounded-full tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-font-medium'>
                        Get treatment
                        <ArrowRightShort />
                      </button>
                    </Link>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                lg={6}
                className='tw-flex tw-mt-6 lg:tw-mt-0 px-lg-0'
              >
                <div className='position-relative tw-w-full tw-h-[343px] lg:tw-h-full'>
                  <Image
                    src={serviceSection3}
                    layout='fill'
                    alt='A woman in a blue blazer uses a tablet at a wooden desk, with a stethoscope and mug beside her.'
                    objectFit='cover'
                    objectPosition='65% center'
                    className='tw-rounded-2xl'
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <Questions />
    </main>
  );
}
const steps = [
  {
    id: 1,
    img: weightLossStep1,
    title: `Complete a Quick Assessment`,
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          Fill out a short form with your symptoms and basic health information
          so a provider can understand your needs.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Takes just a few minutes</li>
          <li>Simple, guided questions</li>
          <li>No commitment</li>
        </ul>
      </div>
    ),
  },
  {
    id: 2,
    img: weightLossStep2,
    title: `Get reviewed by a licensed provider`,
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          A licensed provider carefully reviews your information and determines
          the appropriate treatment.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Reviewed by a qualified provider</li>
          <li>No insurance required</li>
          <li>Treatment based on your responses</li>
        </ul>
      </div>
    ),
  },
  {
    id: 3,
    img: homeStep3,
    title: `Prescription Sent for Pickup`,
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          If approved, your prescription is sent to your selected pharmacy and
          ready for pickup.
        </p>
        <ul className=' tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Sent to your preferred pharmacy</li>
          <li>Ready within hours (in most cases)</li>
          <li>Clear next steps for pickup</li>
        </ul>
      </div>
    ),
  },
];

export async function getStaticProps() {
  try {
    const [data0, data1] = await Promise.all([
      LoadService('Service'),
      LoadServiceCategory('Service'),
    ]);

    const servicesMapped = data1.results.map((ser) => ({
      objectId: ser.objectId,
      title: ser.title ?? null,
      diseases: compact(
        data0.results.map((dis) =>
          ser.objectId === (dis.category && dis.category.objectId)
            ? slimServiceForListing(dis)
            : null
        )
      ),
    }));

    return {
      props: { services: servicesMapped },
      revalidate: 3600,
    };
  } catch (err) {
    console.error('getStaticProps /services failed:', err?.message);
    return {
      props: { services: [] },
      revalidate: 60,
    };
  }
}
function adjustTitle(str) {
  return str
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]/g, ''); // Remove special characters (optional)
}
const Bolt = () => (
  <svg
    width='14'
    height='21'
    viewBox='0 0 14 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8.16185 7.18426V1.09926C8.19185 0.949261 8.13585 0.593261 7.66885 0.374261C7.26185 0.183261 6.81885 0.465261 6.68585 0.648261C4.65685 3.88826 0.870847 10.7053 0.722847 11.0473C0.535847 11.4793 0.662848 11.7493 0.840848 11.9473C0.972848 12.0973 1.28885 12.1853 1.45785 12.1853H5.57385L4.69585 19.6303C4.70885 19.8023 4.85085 20.1753 5.32285 20.2883C5.79485 20.4013 6.11985 20.0603 6.22285 19.8763L12.9528 8.48826C13.0508 8.33826 13.2528 7.93826 13.0378 7.58826C12.9553 7.45811 12.8397 7.35222 12.7028 7.28141C12.566 7.21061 12.4128 7.17742 12.2588 7.18526L8.16185 7.18426Z'
      fill='black'
    />
  </svg>
);
const GreenTick = () => (
  <svg
    width='17'
    height='17'
    viewBox='0 0 17 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.49411 12.3419L13.7608 6.07519L12.5163 4.83074L7.49411 9.85297L4.96078 7.31963L3.71633 8.56408L7.49411 12.3419ZM2.51633 16.6085C2.02744 16.6085 1.60893 16.4344 1.26078 16.0863C0.91263 15.7381 0.738556 15.3196 0.738556 14.8307V2.3863C0.738556 1.89741 0.91263 1.47889 1.26078 1.13074C1.60893 0.782595 2.02744 0.608521 2.51633 0.608521H14.9608C15.4497 0.608521 15.8682 0.782595 16.2163 1.13074C16.5645 1.47889 16.7386 1.89741 16.7386 2.3863V14.8307C16.7386 15.3196 16.5645 15.7381 16.2163 16.0863C15.8682 16.4344 15.4497 16.6085 14.9608 16.6085H2.51633ZM2.51633 14.8307H14.9608V2.3863H2.51633V14.8307Z'
      fill='#009168'
    />
  </svg>
);

const whoBenefitsArray = [
  {
    id: 1,
    title: `Urgent Refills`,
    text: `Patients who need urgent medication refills or prescriptions and cannot reach their primary care doctor.`,
  },
  {
    id: 2,
    title: `Travel Emergencies`,
    text: `Traveling patients who have either run out or misplaced their medicines.`,
  },
  {
    id: 3,
    title: `After Hours`,
    text: `Individuals who need a prescription outside their primary care provider's service hours.`,
  },
];
const BoltGold = () => (
  <svg
    width='9'
    height='14'
    viewBox='0 0 9 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M5.49002 5.0882V1.37011C5.50835 1.27845 5.47414 1.06093 5.18879 0.927115C4.9401 0.810409 4.66942 0.982718 4.58815 1.09454C3.34838 3.07426 1.03503 7.23962 0.944601 7.4486C0.830339 7.71256 0.907939 7.87754 1.0167 7.99852C1.09736 8.09017 1.29044 8.14394 1.39371 8.14394H3.90869L3.37221 12.693C3.38015 12.7981 3.46692 13.026 3.75532 13.0951C4.04373 13.1641 4.24231 12.9558 4.30524 12.8433L8.41745 5.88498C8.47733 5.79333 8.60076 5.54892 8.46939 5.33506C8.41896 5.25553 8.34832 5.19083 8.26469 5.14756C8.18106 5.1043 8.08744 5.08402 7.9934 5.08881L5.49002 5.0882Z'
      fill='#FFBA00'
    />
  </svg>
);
{
  /* <ul className='boltListMobile'>
                  <li>
                    <GreenTick />
                    <span>Same day refill (anywhere in the US)</span>
                  </li>
                  <li>
                    <GreenTick />
                    <span>Get medication refill sent to your pharmacy.</span>
                  </li>
                  <li>
                    <GreenTick />
                    <span>
                      {' '}
                      Professional care 24/7 and an easy prescription refill
                      process.
                    </span>
                  </li>
                </ul> */
}
